import { MapMarkerType } from '@lp/features/RoutePlanner/types';
import { renderMapMarker } from '@lp/features/RoutePlanner/config';
import { OrganType } from '@/api/apis/case';

type MapMarkersProps = {
  organType: OrganType;
  markers: MapMarkerType[];
};

export const MapMarkers = ({ markers, organType }: MapMarkersProps) => {
  return markers.map((data) => renderMapMarker(data, organType, true));
};
